<div class="searchSuggestionWrapper" *ngIf="recentSearchesCardModels.length || suggestionsData.length || assessmentSearchesCardModels.length || customerTagsSearchesCardModels.length || userTagsSearchesCardModels.length ||  resourceTagsSearchesCardModels.length || presentationTagsSearchesCardModels.length==0">
  <div class='defaultSearchSuggestion' *ngIf="!suggestionsData || !suggestionsData.length">
    <ind-section-header *ngIf="recentSearchesCardModels.length" [viewData]='recentSearchesHeaderModel'>
    </ind-section-header>
    <main-card (click)="handleRecentSearchSuggestionClick($event, search)" *ngFor="let search of recentSearchesCardModels; trackBy: trackById"
      [viewData]="search"></main-card>
    <ind-section-header *ngIf="assessmentSearchesCardModels.length" [viewData]='asessmentHeaderModel'>
    </ind-section-header>
    <main-card (click)="handleAssessmentSearchClick($event, search)" *ngFor="let search of assessmentSearchesCardModels; trackBy: trackById"
      [viewData]="search"></main-card>
    <ind-section-header *ngIf="savedSearchesCardModels.length" [viewData]='savedSearchesHeaderModel'>
    </ind-section-header>
    <main-card *ngFor="let search of savedSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>
    <ind-section-header *ngIf="sharedSearchesCardModels.length" [viewData]='sharedSearchesHeaderModel'>
    </ind-section-header>
    <main-card *ngFor="let search of sharedSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>

    <ng-container *ngIf="customerTagsSearchesCardModels.length && !isFromConsentTool">
      <ind-section-header [viewData]='customerTagHeaderModel'>
      </ind-section-header>
      <main-card *ngFor="let search of customerTagsSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>
    </ng-container>
    <ng-container *ngIf="userTagsSearchesCardModels.length && !isFromConsentTool">
      <ind-section-header [viewData]='userTagHeaderModel'>
      </ind-section-header>
      <main-card *ngFor="let search of userTagsSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>
    </ng-container>
    <ng-container *ngIf="presentationTagsSearchesCardModels.length">
      <ind-section-header [viewData]='presentationTagHeaderModel'>
      </ind-section-header>
      <main-card *ngFor="let search of presentationTagsSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>
    </ng-container>
    <ng-container *ngIf="resourceTagsSearchesCardModels.length">
      <ind-section-header [viewData]='resourceTagHeaderModel'>
      </ind-section-header>
      <main-card *ngFor="let search of resourceTagsSearchesCardModels; trackBy: trackById" [viewData]="search"></main-card>
    </ng-container>
  </div>
  <div *ngIf="suggestionsData && suggestionsData.length">
    <div class="filteredSearchSuggestion">
      <ind-section-header *ngIf="suggestionsData[0].header" [viewData]='suggestionsData[0].header'></ind-section-header>
      <main-card *ngFor="let value of suggestionsData[0].listData; trackBy: trackById"
        [ngClass]="{'italics':value.id=='categoryCharacterSearch' || value.id=='entityCharacterSearch' || value.id=='customEntityCharacterSearch' }"
        (click)="handleSuggestionClick($event, value, suggestionsData[0])" [viewData]='value' 
        [highlightMatchKey]="value.id!='categoryCharacterSearch' && value.id!='entityCharacterSearch' && value.id!='customEntityCharacterSearch' && searchKeyValue ? searchKeyValue : null" ></main-card>
    </div>
    <div class="filteredSearchSuggestion" *ngIf="headerModelSaved && savedSearchesCardModels && savedSearchesCardModels.length">
      <ind-section-header  *ngIf="savedSearchesCardModels.length" [viewData]='savedSearchesHeaderModel' >
      </ind-section-header>
      <main-card *ngFor="let value of savedSuggestionsData; trackBy: trackById"
        [ngClass]="{'italics':value.id=='categoryCharacterSearch' || value.id=='entityCharacterSearch' || value.id=='customEntityCharacterSearch' }"
        [viewData]='value' 
        [highlightMatchKey]="value.id!='categoryCharacterSearch' && value.id!='entityCharacterSearch' && value.id!='customEntityCharacterSearch' && searchKeyValue ? searchKeyValue : null" ></main-card>
    </div>
    <div class="filteredSearchSuggestion" *ngIf="headerModelShared && sharedSearchesCardModels && sharedSearchesCardModels.length"  >
      <ind-section-header *ngIf="sharedSearchesCardModels.length" [viewData]='sharedSearchesHeaderModel'>
      </ind-section-header>
      <main-card *ngFor="let value of SharedSuggestionsData; trackBy: trackById"
        [ngClass]="{'italics':value.id=='categoryCharacterSearch' || value.id=='entityCharacterSearch' || value.id=='customEntityCharacterSearch' }"
        [viewData]='value' 
        [highlightMatchKey]="value.id!='categoryCharacterSearch' && value.id!='entityCharacterSearch' && value.id!='customEntityCharacterSearch' && searchKeyValue ? searchKeyValue : null" ></main-card>
    </div>
    <div class="filteredSearchSuggestion">
      <div *ngFor="let category of suggestionsData | slice:1; trackBy: trackById ">
        <ind-section-header *ngIf="category.header" [viewData]='category.header'></ind-section-header>
        <main-card *ngFor="let value of category.listData; trackBy: trackById"
          [ngClass]="{'italics':value.id=='categoryCharacterSearch' || value.id=='entityCharacterSearch' || value.id=='customEntityCharacterSearch' }"
          (click)="handleSuggestionClick($event, value, category)" [viewData]='value' 
          [highlightMatchKey]="value.id!='categoryCharacterSearch' && value.id!='entityCharacterSearch' && value.id!='customEntityCharacterSearch' && searchKeyValue ? searchKeyValue : null" ></main-card>
      </div>
    </div>
  </div>
</div>
